/**
 * Directive which writes the debug messages in a div, instead of the browser console.
 */
angular.module('directives')
    .directive('customDebug', ($translate, $rootScope) => ({
        restrict: 'E',
        replace: true,
        template: require('../../views/directives/custom-debug.html'),
        scope: {},
        link: (scope) => {

            scope.debugObj = $rootScope.Debug;
            scope.customDebug = CWCONFIG.features.customDebug;

        },
    }));



// WEBPACK FOOTER //
// ./scripts/directives/custom-debug.js